import { ChangeEvent } from "react";

import { ErrorMessageComponent } from "@/Common/Components/Errors/ErrorMessageComponent";
import { PatientAdvancedSearchControl } from "@/Common/Components/Search/PatientAdvancedSearchControl";
import { Person } from "@/Common/Models/Person/Person";

interface ILinkMylePatientFunction {
    (selectedPatientId: string, onAddErrorFunction: IPortalManagementPopupErrorFunction, person: Person): void
}

interface IPortalManagementPopupErrorFunction {
    (error: string): void
}

interface ILinkMylePatientToPortalAccountDialogProps {
    onCloseCallback: () => void;
    componentId: string;
    patientContactId: string;
    onAddFunction?: ILinkMylePatientFunction;
    isPortalSearch?: boolean;
}

class LinkMylePatientToPortalAccountState {
    public errors: string[];
    public searchText: string;
    public selectedPatientId: string;
    public selectedPerson: Person;

    constructor(s: LinkMylePatientToPortalAccountState = null) {
        if (s != null) {
            this.searchText = s.searchText;
            this.selectedPatientId = s.selectedPatientId;
            this.errors = s.errors;
            this.selectedPerson = s.selectedPerson;
        }
        else {
            this.searchText = "";
        }
    }
}

/**
 * Used used in portal management to associate a MYLE patient to a portal account (ie add members and such)
 */
class LinkMylePatientToPortalAccountDialog extends React.Component<ILinkMylePatientToPortalAccountDialogProps, LinkMylePatientToPortalAccountState> {
    constructor(props: ILinkMylePatientToPortalAccountDialogProps) {
        super(props);

        const initialState = new LinkMylePatientToPortalAccountState();
        initialState.selectedPatientId = "";
        this.state = initialState;
    }

    public componentDidMount(): void {
        overlayStore.showOverlay("LinkMylePatientToPortalAccountDialog");

        const element = $("#" + this.props.componentId);
        const containment = document.body;
        const dragOptions = {
            containment: containment,
            handle: ".p-header",
            stop() {
                element.draggable("destroy");
                element.css("height", "");
                window.setTimeout(() => {
                    element.draggable(dragOptions);
                }, 80);
            }
        };
        element.draggable(dragOptions);
    }

    public componentDidUpdate(): void {
        $(window).trigger("resize");
    }

    public componentWillUnmount(): void {
        overlayStore.hideOverlay("LinkMylePatientToPortalAccountDialog");
    }

    public render(): JSX.Element {
        return (

            <div className="patient-sync-control" id={this.props.componentId}>
                <div className="pps-header flex-container p-header">
                    <h4>{cacheStore.GetString("PortalPatientSearchAttachFileLabel")}</h4>
                    <span onClick={this.onCloseDialog.bind(this)} className="glyphicon glyphicon-remove pointer" />
                </div>
                <div className="pps-main">

                    <ErrorMessageComponent errors={this.state.errors} />

                    <div className="flex-container split">
                        <div className="portal-search-panel">
                            <div className="ps-pad">
                                <div className="search-component flex-container form-control">
                                    <span className="glyphicon glyphicon-search" />
                                    <input type="text" value={this.state.searchText} onChange={this.onSearchTextChanged.bind(this)} placeholder={cacheStore.GetString("SearchLabel")} />
                                </div>
                            </div>

                            <div className="portal-patients-results">

                                <PatientAdvancedSearchControl
                                    componentId="_portal_mylepatientsearch"
                                    defaultTextValue={this.state.searchText}
                                    maxResultsToReturn={8}
                                    onPatientSelectCallback={this.onSelectPatient.bind(this)}
                                    isFocusOnLoad={true}
                                    isRenderTextbox={false}
                                    isScrollBarActive={false}
                                    isClickOnResultDisabled={false}
                                    isAutoResize={true}
                                    isIncludingInactivePatients={false}
                                    isSearchingPortal={this.props.isPortalSearch}
                                />
                            </div>
                        </div>

                    </div>

                </div>
                <div className="pps-footer flex-container">
                    <button onClick={() => this.props.onCloseCallback()} className="btn btn-default push-right-5"><span>{cacheStore.GetString("CancelLabel")}</span></button>
                    <button onClick={this.onAttachProfileClicked.bind(this)} disabled={this.state.selectedPatientId === ""} className="btn btn-primary"><span>{cacheStore.GetString("LinkLabel")}</span></button>
                </div>
            </div>
        );
    }

    private onSearchTextChanged(e: ChangeEvent<HTMLInputElement>): void {
        const s = new LinkMylePatientToPortalAccountState(this.state);
        s.searchText = e.target.value;
        this.setState(s);
    }

    private onSelectPatient(selectedPerson: Person): void {
        const s = new LinkMylePatientToPortalAccountState(this.state);
        s.selectedPatientId = selectedPerson.ContactId;
        s.selectedPerson = selectedPerson;
        this.setState(s);
    }

    private onAttachProfileClicked(): void {
        this.props.onAddFunction(this.state.selectedPatientId, this.onAddError.bind(this), this.state.selectedPerson);
    }

    private onAddError(err: string): void {
        let s = new LinkMylePatientToPortalAccountState(this.state);
        s.errors = [err];
        this.setState(s);
    }

    private onCloseDialog(): void {
        if (this.props.onCloseCallback != null)
            this.props.onCloseCallback();
    }
}

export { IPortalManagementPopupErrorFunction, LinkMylePatientToPortalAccountDialog };
